export const ANALYTIC_SET_LIST = 'ANALYTIC_SET_LIST';
export const ANALYTIC_SAVE = 'ANALYTIC_SAVE';
